<template>
    <div>
        <filters></filters>
        <short-stats :code-identifier="codeIdentifier"></short-stats>

        <div class="bg-white overflow-hidden shadow sm:rounded-lg mt-4">
            <div class="px-4 py-5 sm:p-6">
                <scans :code-identifier="codeIdentifier"></scans>
            </div>
        </div>


        <div class="mt-4 sm:flex justify-between sm:space-x-4">
            <qr-code-scans-trends :code-identifier="codeIdentifier" class="w-full sm:w-1/3"></qr-code-scans-trends>
            <qr-code-device-trends :code-identifier="codeIdentifier" class="w-full mt-2 sm:mt-0 sm:w-1/3"></qr-code-device-trends>
            <qr-code-cities-trends :code-identifier="codeIdentifier" class="w-full mt-2 sm:mt-0 sm:w-1/3"></qr-code-cities-trends>
        </div>

        <div class="mt-4 sm:flex justify-between sm:space-x-4">
            <destination-trends :code-identifier="codeIdentifier" class="w-full sm:w-2/4"></destination-trends>
            <scans-for-each-hours :code-identifier="codeIdentifier" class=" mt-2 sm:mt-0 w-full sm:w-2/4"></scans-for-each-hours>
        </div>
    </div>
</template>

<script>

import Scans from "@/scripts/components/app/analytics/Scans.vue";
import DestinationTrends from "@/scripts/components/app/analytics/DestinationTrends.vue";
import ScansForEachHours from "@/scripts/components/app/analytics/ScansFroEachHours.vue";

export default {
    components: {
        DestinationTrends,
        Scans,
        ScansForEachHours
    },
    props: {
        codeIdentifier: {
            default: null
        }
    }
}
</script>

<style scoped>

</style>
